import { render, staticRenderFns } from "./suspend-batch-export.vue?vue&type=template&id=721845fc&scoped=true&"
import script from "./suspend-batch-export.vue?vue&type=script&lang=js&"
export * from "./suspend-batch-export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721845fc",
  null
  
)

export default component.exports